<template>
	<b-modal centered id="add-lane-modal" title="Add Lane to Remove Parking" size="lg" ok-title="Add"
		ref="lcrParkingRemovalModal" v-if="lane" @hide="resetFields">
		<b-row>
			<b-col>

				<b-form-group label="Which lane requires parking to be removed?" v-if="lane.parkingLaneId"
					:state="lane.parkingLaneId.status" :invalid-feedback="lane.parkingLaneId.invalidMessage">
					<p>
						NOTE: on a one way street the right hand side is the Curb Lane and
						the left hand side is the Median Lane.
					</p>
					<b-form-select v-model="lane.parkingLaneId.value" id="select-parking-lane" autofocus
						:options="parkingLaneRemovalOptions" stacked @change="lane.parkingLaneId.resetStatus()"
						:state="lane.parkingLaneId.status" :invalid-feedback="lane.parkingLaneId.invalidMessage">
					</b-form-select>
				</b-form-group>

				<b-form-group>
					<a :href="getParkingSpotMapLink" class="btn btn-show-map mb-3" target="_blank">Show Map of Parking Spots
						(opens in new window)</a>
				</b-form-group>


				<b-form-group label="How much parking do you need removed? MEASURE IN METERS"
					v-if="lane.parkingRemovalMetres" :state="lane.parkingRemovalMetres.status"
					:invalid-feedback="lane.parkingRemovalMetres.invalidMessage">
					<b-input-group class="lw-25 mw-50" append="m">
						<b-form-input placeholder="Enter in meters" v-model="lane.parkingRemovalMetres.value"
							@input="lane.parkingRemovalMetres.resetStatus()"
							:state="lane.parkingRemovalMetres.status"></b-form-input>
					</b-input-group>
				</b-form-group>

				<b-form-group label="Starting Point for Parking Removal" label-for="ig-start-parking-removal"
					v-if="lane.parkingStartAddress" :state="lane.parkingStartAddress.status"
					:invalid-feedback="lane.parkingStartAddress.invalidMessage">
					<p>Use the closest starting street address</p>
					<b-form-input maxlength="200" id="ig-start-parking-removal" v-model="lane.parkingStartAddress.value"
						@input="lane.parkingStartAddress.resetStatus()" :state="lane.parkingStartAddress.status" />
				</b-form-group>

				<b-form-group label="Ending Point for Parking Removal" label-for="ig-end-parking-removal"
					v-if="lane.parkingEndAddress" :state="lane.parkingEndAddress.status"
					:invalid-feedback="lane.parkingEndAddress.invalidMessage">
					<p>Use the closest ending street address</p>
					<b-form-input maxlength="200" id="ig-end-parking-removal" v-model="lane.parkingEndAddress.value"
						@input="lane.parkingEndAddress.resetStatus()" :state="lane.parkingEndAddress.status" />
				</b-form-group>
			</b-col>
		</b-row>
		<template v-slot:modal-footer="{ ok }">
			<b-button variant="primary" @click="saveOrUpdateLaneForParkingRemoval()">Save</b-button>
			<b-button variant="secondary" @click="cancelAddLaneForParkingRemoval()">Cancel</b-button>
		</template>
	</b-modal>
</template>

<script>
import Vue from 'vue'

import LaneClosureRequestParkingRemoval from '@/models/LaneClosureRequestParkingRemoval';

export default {
	props: {
		isEditingParkingRemoval: {
			type: Boolean,
			default: false
		},
		laneInfoToEditParkingRemoval: {
			type: Object,
		},
		parkingLaneRemovalOptions: {
			type: Array,
			required: true,
		},
		lcrDirectionId: {
			type: Number,
			default: 1
		},
		laneIndexToEditParkingRemoval: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			lane: new LaneClosureRequestParkingRemoval(), // Initialize with an instance of the model
		};
	},
	created() {
		// Set the initial state when the component is created
	},
	computed: {
		getParkingSpotMapLink() {
			let comma = "";
			let url = this.$store.state.paidParkingLotMapUrl;
			let link =  url + "&ll=";
			for (var x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				let polyBounds = this.$store.getters["map/polylines"][x].getPath();
				for (var z = 0; z < polyBounds.length; z++) {
					link += comma + polyBounds.getAt(z).lat() + "%2c" + polyBounds.getAt(z).lng();
					break;
				}
				break;
			}
			link += "&z=18";
			return link;
		},
	},
	mounted() {

	},
	beforeDestroy() {

	},
	methods: {
		selectDefaultLane() {
			this.lane = Object.assign({}, this.lane); // Stop reactivity for lane object
			// Automatically populate the likely lane id based on what the direction is.
			// westbound median
			if (this.lcrDirectionId == 4 || this.lcrDirectionId == 5) {
				Vue.set(this.lane.parkingLaneId, 'value', 6);
			}

			// eastbound median.
			if (this.lcrDirectionId == 3 || this.lcrDirectionId == 5) {
				Vue.set(this.lane.parkingLaneId, 'value', 3);
			}

			// southbound median.
			if (this.lcrDirectionId == 2 || this.lcrDirectionId == 6) {
				Vue.set(this.lane.parkingLaneId, 'value', 12);
			}

			// northbound median.
			if (this.lcrDirectionId == 1 || this.lcrDirectionId == 6) {
				Vue.set(this.lane.parkingLaneId, 'value', 9);
			}
		},
		openModal() {
			this.$refs.lcrParkingRemovalModal.show();
		},
		closeModal() {
			this.resetFields(); // Reset fields when closing the modal
			this.$refs.lcrParkingRemovalModal.hide();
		},
		saveOrUpdateLaneForParkingRemoval() {
			let dataToSend = {
				id: this.lane.id.value ? this.lane.id.value : null,
				parkingLaneId: this.lane.parkingLaneId.value,
				parkingRemovalMetres: parseFloat(this.lane.parkingRemovalMetres.value),
				parkingStartAddress: this.lane.parkingStartAddress.value,
				parkingEndAddress: this.lane.parkingEndAddress.value,
			};
			if (!this.validateFields()) {
				return; //do not save if validation fails
			}
			if (this.isEditingParkingRemoval == true) {
				// Emit the updated lane data to the parent component
				this.$emit('submit-updated-parking-removal-data', this.laneIndexToEditParkingRemoval, { ...dataToSend });
			} else {
				// Emit the new lane data to the parent component
				this.$emit('submit-new-parking-removal-data', { ...dataToSend });
			}
			this.closeModal();
		},
		cancelAddLaneForParkingRemoval() {
			this.closeModal();
		},
		resetFields() {
			// Reset to initial state when the modal is closed
		},

		validateFields() {
			const { parkingLaneId, parkingRemovalMetres, parkingStartAddress, parkingEndAddress } = this.lane;
			let validated = parkingLaneId.value && parkingRemovalMetres.value && parkingStartAddress.value && parkingEndAddress.value;
			if (!validated) {
				// Show an error message or highlight the fields with errors
				this.showFieldErrors();
				return false;
			}
			if (!this.isNumber(parkingRemovalMetres.value)) {
				this.showNumberError(parkingRemovalMetres);
				return false;
			}
			if (parseFloat(parkingRemovalMetres.value) <= 0) {
				this.showNumberError(parkingRemovalMetres);
				return false;
			}
			return true;
		},
		showFieldErrors() {
			const { id, parkingLaneId, parkingRemovalMetres, parkingStartAddress, parkingEndAddress } = this.lane;
			this.showFieldError(id);
			this.showFieldError(parkingLaneId);
			this.showFieldError(parkingRemovalMetres);
			this.showFieldError(parkingStartAddress);
			this.showFieldError(parkingEndAddress);
		},
		showFieldError(field) {
			if (!field.value) {
				field.status = false; // Set the field status to indicate an error
				field.invalidMessage = 'This field is required';
			}
		},
		isNumber(value) {
			return !isNaN(parseFloat(value)) && isFinite(value);
		},
		showNumberError(field) {
			field.status = false; // Set the field status to indicate an error
			field.invalidMessage = 'Please enter a valid number';
		},
	},
	watch: {
		laneInfoToEditParkingRemoval: {
			handler(newVal) {
				if (Object.keys(newVal).length > 0) {
					this.lane = { ...newVal }
					this.selectDefaultLane();
				}
			},
			immediate: true // To ensure the watch handler is executed immediately
		},

	}
}
</script>